import { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTooltip } from 'src/components/CustomTooltip';
import { GenerationToolIcon } from 'src/components/GenerationToolIcon';
import {
  GENERATION_TOOL,
  getMultiPromptSubtools,
  isMultiPromptTool,
} from 'src/data/generationTool';
import { getMultiPromptTemplateBlockTypes } from 'src/data/template';

import { useStyles } from './useStyles';
import { generateToolListTooltip } from './utils';

const propTypes = {
  className: PropTypes.string,
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)).isRequired,
  customToolData: PropTypes.shape({}),
  title: PropTypes.string.isRequired,
};

const defaultProps = {
  className: null,
  customToolData: null,
};

const MAX_DISPLAYED_TOOLS = 3;

export const CardToolsIcons = ({ className, generationTool, customToolData, title }) => {
  const styles = useStyles();

  const toolList = useMemo(() => {
    if (generationTool === GENERATION_TOOL.customMultiPrompt) {
      return getMultiPromptTemplateBlockTypes(customToolData);
    } else if (isMultiPromptTool(generationTool)) {
      return [...new Set(Object.values(getMultiPromptSubtools(generationTool)))];
    }
    return [generationTool];
  }, [generationTool, customToolData]);

  const tooltipTitle = toolList.length > 1 ? generateToolListTooltip(toolList) : title;

  return (
    <CustomTooltip
      title={tooltipTitle}
      placement="bottom"
    >
      <div className={cx(styles.root, className)}>
        {toolList.length > MAX_DISPLAYED_TOOLS && (
          <div
            className={styles.circle}
            style={{ zIndex: MAX_DISPLAYED_TOOLS + 1 }} // Icons overlap in reverse flow order
          >
            <span className={styles.moreTools}>+{toolList.length - MAX_DISPLAYED_TOOLS}</span>
          </div>
        )}

        {toolList.slice(0, MAX_DISPLAYED_TOOLS).map((tool, index) => (
          <div
            className={styles.circle}
            key={tool}
            style={{ zIndex: MAX_DISPLAYED_TOOLS - index }} // Icons overlap in reverse flow order
          >
            <GenerationToolIcon
              className={styles.icon}
              tool={tool}
            />
          </div>
        ))}
      </div>
    </CustomTooltip>
  );
};

CardToolsIcons.displayName = 'CardToolsIcons';
CardToolsIcons.propTypes = propTypes;
CardToolsIcons.defaultProps = defaultProps;
